import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type CertidaoSuspensaoPjJob = ReportJob;
export type CertidaoSuspensaoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Suspensão PJ. */
@Injectable({ providedIn: 'root' })
export class CertidaoSuspensaoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-suspensao-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certidaoSuspensaoPj;
}
